// extracted by mini-css-extract-plugin
export var searchHeader = "_42-0";
export var searchHeaderDark = "_42-1";